module.exports = __webpack_public_path__ + "static/media/business.2f876e8e.jpg";